// pages/module-pages/job-offers/NewJobOfferPage.tsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BaseJobOffer } from "../../../types/features/JobOffer";

import PageLayout from "../../../layouts/PageLayout";
import PageContainer from "../../../components/ui/PageContainer";
import useJobOffers from "../../../hooks/features/job-offers/useJobOffers";
import JobOfferForm from "../../../components/shared/job-offers/JobOfferForm";
import useAuth from "../../../hooks/features/auth/useAuth";
import { alertError } from "../../../helpers/alertError";

export default function NewJobOfferPage() {
  const navigate = useNavigate();
  const { createJobOffer } = useJobOffers();
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const generateSlug = (title: string): string => {
    return title
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");
  };

  const handleSubmit = async (data: BaseJobOffer, imageFile?: File) => {
    setIsLoading(true);

    if (!user?.id || user.role !== "admin") {
      alertError("Veillez vous cnnecter e tant qu'admin avant de publier ");
      return;
    }

    const coverImageUrl = data.cover_image;

    // Upload de l'image si présente

    const slug = generateSlug(data.title);
    const success = await createJobOffer({
      ...data,
      slug,
      cover_image: coverImageUrl,
    });

    setIsLoading(false);
    if (success) {
      navigate("/admin/job-offers");
    }
  };

  return (
    <PageLayout title="Nouvelle offre d'emploi" className="p-6 max-w-4xl mx-auto">
      <PageContainer>
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Nouvelle offre d'emploi</h1>
          <p className="text-gray-500 mt-1">Publiez une nouvelle offre de recrutement</p>
        </div>
        <JobOfferForm onSubmit={handleSubmit} isLoading={isLoading} />
      </PageContainer>
    </PageLayout>
  );
}
